import { request } from "../helpers/axios";

export const GET_APP_VERSION = () => {
  return request({
    url: '/version', 
    method: "GET"
  });
};